import AlgorithmList from "../components/AlgorithmList";

function Main() {
  return (
    <>
      <AlgorithmList></AlgorithmList>
    </>
  );
}
export default Main;
